import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ClassificationValueUpdate,
  deleteClassificationValue,
  setClassificationDefaultTitle,
  updateClassificationValue,
} from "../../../ducks/classification/classification";
import { getSelectedSegment } from "../../../ducks/style/selectors";

export const useClassificationUpdate = () => {
  const dispatch = useDispatch();
  const selectedSegment = useSelector(getSelectedSegment);

  const onChange = useCallback(
    (valueUpdate: ClassificationValueUpdate) => {
      if (valueUpdate.value !== undefined) {
        dispatch(updateClassificationValue({ ...valueUpdate, selectedSegment }));
      }
    },
    [dispatch, selectedSegment],
  );

  const setDefaultTitle = useCallback(
    (title: string) => dispatch(setClassificationDefaultTitle({ defaultTitle: title, selectedSegment })),
    [dispatch, selectedSegment],
  );

  const onDelete = useCallback(
    (index: number) => dispatch(deleteClassificationValue({ index, selectedSegment })),
    [dispatch, selectedSegment],
  );

  return {
    onChange,
    onDelete,
    setDefaultTitle,
  };
};
